// extracted by mini-css-extract-plugin
export default {"resetButton":"_cvXPNB","editorSkeleton":"OqXd_cf","editorLayout":"rVvQx4T","draft":"dWp2MXK","collapsed":"YeSdu1a","editorContainer":"TFpSBRq","editor":"Nil091X"};